import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Status } from '@/models/status.model';
import { WidgetTeacherPerson } from '@/homework/models/widget-teacher-person.model';
import { HOMEWORK_STATUS_ICON, HOMEWORK_STATUS, HOMEWORKS_EVENTS } from '@/homework/values/homeworks.values';

@Component({
  name: 'ed-homework-widget-person',
  components: {
    EdBadge: () => import(/* EdBadge */ '../../../components/common/ed-badge/ed-badge.vue'), 
  }
})
export default class EdHomeworkWidgetPerson extends Vue {

  @Prop() readonly widgetPerson : WidgetTeacherPerson;
  
  public personsStatus: Status = new Status();

  get name(): string {
    return this.widgetPerson.fullName;
  }

  get status() {
    return this.widgetPerson.homeworkStatus;
  }

  get personSelected(): WidgetTeacherPerson {
    return this.$store.state.HomeworksStore.teacherWidgetHomeworks.personSelected;
  }

  get selected(): boolean {
    if (this.personSelected) {
      return (this.widgetPerson.id == this.personSelected.id
        && this.widgetPerson.classId == this.personSelected.classId
        && this.widgetPerson.courseId == this.personSelected.courseId
      );
    }

    return false;
  }

  get badge(): boolean {
    return this.widgetPerson.homeworkStatus == HOMEWORK_STATUS.NEW;
  }

  get icon() {
    if(this.widgetPerson.homeworkStatus == HOMEWORK_STATUS.NEW) {
      return HOMEWORK_STATUS_ICON.ICON_SEEN;
    } else {
      return HOMEWORK_STATUS_ICON[`ICON_${this.widgetPerson.homeworkStatus}`];
    }
  }

  get listIdsToReload(): Array<number> {
    return this.$store.state.HomeworksStore.listIdsToReloadTasks;
  }

  selectPerson() {
    this.$edEventBus.$emit(HOMEWORKS_EVENTS.LOAD_STUDENT_HOMEWORKS_TEACHER_WIDGET, this.widgetPerson, false);
    if(this.listIdsToReload.length > 0) {
     let reload: boolean = this.listIdsToReload.includes(this.widgetPerson.courseId);
     if(reload)
      this.$edEventBus.$emit(HOMEWORKS_EVENTS.RELOAD_STUDENT_HOMEWORKS_TEACHER_WIDGET, true);
    }
  }


}



